/**
 * Created by piotr.pozniak@thebeaverhead.com on 14/11/2024
 */

import React from "react";
import { useTranslation } from "react-i18next";

const Card = ({}) => (
  <div
    className={"card-view--card dc-flex-1 rev--loader-card-item "}
    aria-hidden="true"
  >
    <div className={"rev-preloader-block"}></div>
  </div>
);

const LoaderIndicator = () => {
  const { t } = useTranslation();

  return (
    <>
      <span className="sr-only" role="status">
        {t("Loading events")}
      </span>
      <Card />
      <Card />
      <Card />
    </>
  );
};

export default LoaderIndicator;
